import { TeamOutlined } from '@ant-design/icons'
import { Button, Space, Tag, Tooltip } from 'antd'

import { queryMemberGroupApi } from '@eastcoal/api/auth/group/queryMemberGroup'
import { MemberEntity } from '@eastcoal/api/auth/interface'

import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'

import { useCrudFormStore } from '@eastcoal/formily/components/CrudForm/Store/hooks/useStore'

import { formatterDetail } from '../CustomGroupForm/utils'
import { useCustomMemberGroupStore } from '../Store/hooks'

export const CheckCustomGroupMembersButton = () => {
  const { modal } = useFeedback()
  const { form } = useCrudFormStore(state => pick(state, ['form']))
  const { value, currentGroup, disabled } = useCustomMemberGroupStore(state =>
    pick(state, ['disabled', 'currentGroup', 'value'])
  )

  const temporaryGroup = currentGroup || value?.find(group => group.temporary)

  const onClick = async () => {
    let customMembers: MemberEntity[] | undefined
    if (temporaryGroup && !temporaryGroup?.members?.length) {
      await queryMemberGroupApi({
        id: temporaryGroup?.id
      }).then(detail => {
        customMembers = formatterDetail(detail)?.members
      })
    } else {
      customMembers = temporaryGroup?.members
    }

    modal.info({
      title: '自定义分组会员',
      content: (
        <Space wrap>
          {customMembers?.map(member => (
            <Tag key={member.id}>{member.name}</Tag>
          ))}
        </Space>
      ),
      okText: '确定'
    })
  }

  return !disabled || !form.values.limitMember ? null : (
    <Tooltip title='点击查看自定义分组会员'>
      <Button icon={<TeamOutlined />} type='link' onClick={onClick} />
    </Tooltip>
  )
}
